module.exports = __webpack_public_path__ + "img/PR8812.128cd167.png";